<template>
	<div v-if="false" />
</template>

<script>
import cookie from 'cookie_js'
import { loadScript } from '@/utils'
import { config } from '@/config'

export default {
	props: {},
	data() {
		return {
			map: this.$root?.options?.map
		}
	},
	async mounted() {
		if (!this.hasFeature('FEATURE_COUNTRY_REDIRECT') || !this.map || !Array.isArray(this.map) || cookie.get(config.COUNTRY_REDIRECT_COOKIE) === 'false') {
			return
		}

		try {
			await loadScript('//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
			const { country: { iso_code: countryCode } } = await new Promise((resolve, reject) => {
				geoip2.country(resolve, reject, {})
			})
			const target = this.map.find(t => t.countryCode.includes(countryCode) && t.themeName === this.themeName)

			if (target) {
				const confirmed = await this.$store.dispatch('dialog/showDialog', {
					title: this.$t(`countryredirect.${countryCode}.title`),
					message: this.$t(`countryredirect.${countryCode}.text`),
					confirm: this.$t(`countryredirect.${countryCode}.confirm`),
					cancel: this.$t(`countryredirect.${countryCode}.cancel`),
				});

				if (confirmed) {
					window.location.href = target.targetUrl
				}
				else {
					cookie.set(config.COUNTRY_REDIRECT_COOKIE, 'false', {path: '/'})
				}
			}
		}
		catch(err) {
			console.error(err)
		}
	}
}
</script>
